import { api } from "../Apis/interceptor";

export const getByYear = function (customer_id, year) {
  return api.get("/api/v1/logframe/" + customer_id + "/" + year);
};

export const saveUpdate = function (customer_id, logFrameData) {
  return api.put("/api/v1/updateLogFramePlan/" + customer_id, logFrameData);
};
